import actions from './actions';
import getters from './getters';
import mutations from './mutations';




const state = {
    hasSlider: false,
    activeSlideID: 0,
    sliderActive: false,
    sliderContent: {},


};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};


// WEBPACK FOOTER //
// ./src/store/slider/index.js